export const transactionTypes = {
  OnlinePayment : 'online payment',
  Fpx : 'fpx',
  CreditCard : 'credit card',
  SmartFund : 'smart fund',
  Cheque : 'cheque',
  Cash : 'cash',
  UploadReceipt : 'upload receipt',
}

export const transTypes = [
  {
    key: transactionTypes.OnlinePayment,
    label: transactionTypes.OnlinePayment,
  },
  {
    key: transactionTypes.Fpx,
    label: transactionTypes.Fpx,
  },
  {
    key: transactionTypes.CreditCard,
    label: transactionTypes.CreditCard,
  },
  {
    key: transactionTypes.SmartFund,
    label: transactionTypes.SmartFund,
  },
  {
    key: transactionTypes.Cheque,
    label: transactionTypes.Cheque,
  },
  {
    key: transactionTypes.Cash,
    label: transactionTypes.Cash,
  },
  {
    key: transactionTypes.UploadReceipt,
    label: transactionTypes.UploadReceipt,
  }
];


